$(document).ready(function () {

  if($('.banner_list .banner-slide').length > 1){  
    $('.banner_list').slick({
      slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true
    });
  }
  

  $(".reviews-slider").slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1366,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 551,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
  });


  $(".teams-grid").slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1366,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
  });

   $('.product-slider').slick({
    dots: false,
    arrows:true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
   

   $('.sorority-slider').slick({
    dots: false,
    arrows:true,
    infinite: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

   $('.cat-list-slider').slick({
    dots: false,
    arrows:true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

});
// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


document.querySelectorAll('.main_mega_menu .list-menu > li').forEach(li => {
  li.addEventListener('mouseenter', function () {
    this.classList.add('active-hover');
  });

  li.addEventListener('mouseleave', function () {
    this.classList.remove('active-hover');
  });
});

const menuItems = document.querySelectorAll('.mobile-menu .list-menu > li');
const body = document.body;

menuItems.forEach(li => {
  li.addEventListener('click', function (e) {

    // if (e.target.closest('a')) {
    //   return; // do nothing, allow navigation
    // }

    e.stopPropagation();

    const isActive = this.classList.contains('active-click');

    // remove all active classes
    menuItems.forEach(el => el.classList.remove('active-click'));

    if (!isActive) {
      this.classList.add('active-click');
    }

  });
});

// star review click slide down to review tab

document.addEventListener('DOMContentLoaded', () => {
  const reviewWidget = document.querySelector('#product-right .jdgm-widget');
  const tabTrigger   = document.querySelector('.tab-container .tabs li[rel="tab2"]');

  if (!reviewWidget || !tabTrigger) return;

  reviewWidget.addEventListener('click', (e) => {
    e.preventDefault();

    // Trigger tab click
    tabTrigger.click();

    // Scroll to tab container (or tab content)
    const tabContainer = document.querySelector('.tab-container');

    if (tabContainer) {
      tabContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});


window.addEventListener("scroll", function () {
  const header = document.querySelector(".header-section");

  if (window.scrollY > 0) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
});



